<template>
  <div class="rounded-lg border bg-card p-6">
    <h3 class="text-base font-semibold text-foreground">{{ $ts('checkout.quickCheckout.title') }}</h3>

    <div class="mt-4 grid grid-cols-3 gap-3">
      <button
        v-for="provider in providers"
        :key="provider.name"
        class="flex items-center justify-center gap-2 rounded-lg border border-input bg-background px-4 py-2.5 text-sm font-medium text-foreground transition-colors hover:bg-accent"
        @click="emit('select', provider.name)"
      >
        <Icon :name="provider.icon" size="18" />
        {{ provider.label }}
      </button>
    </div>

    <div class="mt-4 flex items-center gap-3">
      <Separator class="flex-1" />
      <span class="text-sm text-muted-foreground">{{ $ts('checkout.quickCheckout.orContinueAsGuest') }}</span>
      <Separator class="flex-1" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '#imports';
import Separator from '#bubba/shared/components/ui/separator/Separator.vue';

const { $ts } = useI18n();

const emit = defineEmits<{
  select: [provider: string];
}>();

const providers = [
  { name: 'google', icon: 'devicon:google', label: 'Google' },
  { name: 'apple', icon: 'devicon:apple', label: 'Apple' },
  { name: 'facebook', icon: 'logos:facebook', label: 'Facebook' },
];
</script>
